import React from 'react'
import FeedbackForm from './FeedbackForm'
import FeedbackContent from './FeedbackContent'
import TextImage from "../../shared/components/LayoutComponents/TextImage";

export interface Feedback {
  createdAt: Date
  content: string
  rating: number
  name: string
  id: string
  public: boolean
}

export interface Props {
  reloadFeedback: () => void
}
const Feedback: React.FC<Props> = (props) => {
  return (
    <>
      <FeedbackForm reloadFeedback={props.reloadFeedback} />
      <FeedbackContent />
      <TextImage
        imagePath='./images/Girls_Day-Logo_16x9.webp'
        headline2='Lust auf Girls Day bei uns?'
        content=' Wenn ihr Lust habt auch einen Tag bei uns zu erleben, seid ihr herzlich Willkommen.
        Die Anmeldung erfolgt über die Girls Day Website:
https://www.girls-day.de/.
Genauere Informationen erhaltet ihr per Email nach der Anmeldung.'
      />
    </>
  )
}
export default Feedback
